<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="false">
        <div slot="header">
          <span>配送至：</span>
          <div class="adressBox">
            <div v-if="address.isDefault" class="defTab">
              默认
            </div>
            <div class="item">
              {{ address.receiverName }}
            </div>
            <div class="item">
              {{ address.province }}
            </div>
            <div class="item">
              {{ address.city }}
            </div>
            <div class="item">
              {{ address.county }}
            </div>
            <div class="item">
              {{ address.receiptAddress }}
            </div>
            <div class="item">
              {{ address.receiverPhone }}
            </div>
          </div>
          <span>
            <!-- v-if="!infoAll.freightContract" -->
            <el-button v-if=" address.receiverName" type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">更改地址</el-button>
            <el-button v-else type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">选择地址</el-button>
          </span>
        </div>
        <slot name="freightInfo" />
        <div style="padding: 20px">
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker
                v-model="allAttribute.time"
                :picker-options="setBatchPickerOptions()"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择期望发货日期"
              />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="batchSettings">
                批量设置
              </el-button>
            </el-form-item>
          </el-form>

          <div v-if="isDisabledConType" style="color:red">
            注:1.若批量设置的日期不在客期可选范围,则需要重新设置或在产品行上单独设置
            2.若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
          </div>

          <el-table :data="tableData"
                    border
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    class="productTable"
                    :height="tableHeight"
          >
            <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
            <el-table-column prop="rproductInvoiceName" label="产品名称" align="left" min-width="160" />
            <el-table-column prop="rproductName" label="产品型号" align="left" min-width="160" />
            <el-table-column prop="rproductNum" label="数量" align="left" width="100" />
            <el-table-column prop="rproductUnit" label="单位" align="left" width="50" />
            <el-table-column prop="rproductPrice" label="单价" align="right" header-align="left" width="110" />
            <el-table-column prop="rproductPriceAdd" label="订单金额" align="right" header-align="left" width="110">
              <!-- <template v-slot="{row}">
                {{ Number(row.orderAmount).toFixed(2) }}
              </template> -->
            </el-table-column>
            <el-table-column prop="roldProductActualPrice" label="原实际结算金额" align="right" header-align="left" width="110">
              <template v-slot="{ row }">
                {{ setProductActualPrice(row) }}
              </template>
            </el-table-column>
            <el-table-column prop="rproductActualPriceAdd" label="实际结算金额" align="right" header-align="left" width="110" />

            <el-table-column
              prop="rexpectedDeliveryDate"
              label="期望发货日期"
              align="left"
              min-width="160"
            >
              <template v-slot="{row}">
                <el-date-picker
                  v-model="row.rexpectedDeliveryDate"
                  type="date"
                  style="width:100%;"
                  value-format="yyyy-MM-dd"
                  placeholder="期望发货日期"
                  :clearable="false"
                  :picker-options="setSinglePickerOptions(row)"
                />
              </template>
            </el-table-column>

            <el-table-column v-if="isDisabledConType" label="客期可选范围" align="left" min-width="180">
              <template v-slot="{row}">
                <span>{{ setFormatRangDate(row) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="rbeforeSplitPrice" label="拆分前单价" align="right" header-align="left" width="110" />
            <el-table-column prop="risBuyPsc" label="是否购买PSC" align="left" width="100">
              <template v-slot="{row}">
                {{ row.risBuyPsc?'是':'否' }}
              </template>
            </el-table-column>

            <el-table-column
              prop="taxRate"
              label="税率"
              align="right"
              header-align="left"
              width="120"
            />
            <!-- <el-table-column prop="productConfigInfo" label="产品物料描述" align="left" width="100" /> -->
          </el-table>
        </div>
      </Collapse>
      <slot />
    </div>
    <address-box :prop-open.sync="showAddress" @chooseAddress="changeAddress" @ChangeDatas="ChangeDatas" />
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import addressBox from '@/views/address/index.vue';
import { MathAdd, MathMulti } from '@/libs/util';
import { aggetReceiptAddressByContractNum, getReceiptAddressInfoModel } from '@/API';
import dayjs from 'dayjs';

export default {
  components: {
    Collapse,
    addressBox
  },

  props: {

    productList: {
      type: Array,
      default () {
        return [];
      }
    },
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    }
  },

  data () {
    return {
      allAttribute: {
        time: ''
      },
      tableData: [],
      rejectedList: this.productList,
      showAddress: false,
      loading: true,
      address: {},
      finalNetSales: 0,
      orderSales: 0,
      tableHeight: 300
    };
  },

  computed: {
    // 只处理换货合同的客期禁用规则
    isDisabledConType () {
      return ['换货合同'].includes(this.$route.query.rcontractType);
    }
  },
  watch: {
    productList (val) {
      this.rejectedList = val;
      this.tableData = val ? val[0].addressList[0].contractProductList : [];
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    // 设置批量设置客期的禁用规则，规则：满足条件的当天开始的90天可以选择
    setBatchPickerOptions () {
      let _this = this;
      return {
        disabledDate (time) {
          if (_this.isDisabledConType) {
            return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(89, 'day'));
          }
          return false;
        }
      };
    },

    // 设置产品行客期的禁用规则，规则：满足条件的当天开始的90天可以选择
    setSinglePickerOptions (row) {
      let _this = this;

      return {
        disabledDate (time) {
          return _this.getRowDisabledRule(row, time);
        }
      };
    },

    // 产品行规则 小于开始，大于结束，中间的法定节假日 禁用
    getRowDisabledRule (row, time) {
      if (this.isDisabledConType) {
        let { minExpectedDate, maxExpectedDate, holidayDates } = row;
        if (minExpectedDate && maxExpectedDate && holidayDates) {
          return dayjs(time).isBefore(dayjs(minExpectedDate)) || holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')) || dayjs(time).isAfter(dayjs(maxExpectedDate));
        } else {
          return false;
        }
      }
      return false;
    },

    // 客期可选范围
    setFormatRangDate (row) {
      let { minExpectedDate, maxExpectedDate } = row;
      if (minExpectedDate && maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ ${maxExpectedDate.slice(0, 10)}`;
      }
    },

    initData () {
      this.loading = false;
      let params = { newContractNum: this.$route.query.rnewContractNum };
      aggetReceiptAddressByContractNum(params).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          let data = json.data;
          if (data === null) {
            data = [];
          }
          this.address = data;
          this.$emit('chooseAddress', json.data);
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    // 批量设置
    batchSettings () {
      if (!this.rejectedList.length) return;

      this.rejectedList[0].addressList[0].contractProductList.forEach((row) => {
        if (this.allAttribute.time) {
          // 产品行符合禁用规则可以进行赋值
          if (!this.getRowDisabledRule(row, this.allAttribute.time)) {
            this.$set(row, 'rexpectedDeliveryDate', this.allAttribute.time);
          }
        }
      });
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal(param.data);
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.computePriceTotal(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.productActualPriceTotal(param.data);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.beProductUnitPriceTotal(param.data);
        }
      });
      return sums;
    },
    // 数量总计
    AmountTotal (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductNum);
      });
      return cont;
    },
    // 实际结算金额
    productActualPriceTotal (tag) {
      // let cont = 0;
      // let product = this.rejectedList[0].addressList[0].contractProductList;
      // if (product.length !== 0) {
      //   product.forEach((item) => {
      //     cont += item.rproductActualPriceAdd;
      //   });
      // }
      // return cont;
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductActualPriceAdd);
      });
      return cont.toFixed(2);
    },
    // 订单金额总计
    computePriceTotal (tag) {
      // let cont = 0;
      // let product = this.rejectedList[0].addressList[0].contractProductList;
      // if (product.length !== 0) {
      //   product.forEach((item) => {
      //     cont += item.rProductPriceAdd;
      //   });
      // }
      // return cont;
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductPriceAdd);
      });
      return cont.toFixed(2);
    },
    // 拆分前单价总计
    beProductUnitPriceTotal (tag) {
      // let cont = 0;
      // let product = this.rejectedList[0].addressList[0].contractProductList;
      // if (product.length !== 0) {
      //   product.forEach((item) => {
      //     cont += item.rproductNum;
      //   });
      // }
      // return cont;
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rbeforeSplitPrice);
      });
      return cont.toFixed(2);
    },
    changeAddress (val) {
      this.rejectedList[0].addressList[0].rfullAddress = `${val.province}${val.city}${val.receiptAddress}`;
      this.rejectedList[0].addressList[0].rid = val.id;
      this.rejectedList[0].addressList[0].rreceiveTel = val.receiverUnit;
      this.rejectedList[0].addressList[0].rreceiveUserName = val.receiverName;
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      this.$emit('chooseAddress', val);
      this.$emit('changeAddress');
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch(() => {

        });
      }
    },
    validate () {
      let error = '';
      const addressList = this.rejectedList || [];
      addressList.some((addressItem) => {
        const list = addressItem.addressList || [];
        return list.some((address) => {
          const products = address.contractProductList || [];
          return products.some((product) => {
            if (!product.rexpectedDeliveryDate) {
              error = '存在产品未选择期望发货日期';
              return true;
            }
            return false;
          });
        });
      });

      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            title: error
          });
          reject(new Error(error));
        } else {
          resolve(addressList);
        }
      });
    },

    setProductActualPrice ({ roldProductActualPrice, rproductNum }) {
      return MathMulti(roldProductActualPrice, rproductNum);
    }
  }

};
</script>
<style lang="scss" scoped>
  .productTable{
    .el-table__footer-wrapper tbody td{
      background: #fff;
    }
  }
  /* adress
-------------------------- */
  .adressBox{
    display: inline-block;
    .item{
      display: inline-block;
      margin-right: 6px;
    }
    .defTab{
      padding: 3px 10px;
      display: inline-block;
      background: #1b73ff;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
</style>
